'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _ContentCardImage = require('../ContentCardImage');

var _ContentCardImage2 = _interopRequireDefault(_ContentCardImage);

var _ContentCardGallery = require('./ContentCardGallery.css');

var _ContentCardGallery2 = _interopRequireDefault(_ContentCardGallery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * Include the slick css files locally in your project.
 * These were left out because of compilation issues with NextJS in thescore-web
 * 'slick-carousel/slick/slick.css';
 * 'slick-carousel/slick/slick-theme.css';
 */

var ContentCardGallery = function (_React$Component) {
  _inherits(ContentCardGallery, _React$Component);

  function ContentCardGallery(props) {
    _classCallCheck(this, ContentCardGallery);

    var _this = _possibleConstructorReturn(this, (ContentCardGallery.__proto__ || Object.getPrototypeOf(ContentCardGallery)).call(this, props));

    _this.state = {
      mounted: false
    };
    return _this;
  }

  _createClass(ContentCardGallery, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setMounted();
    }
  }, {
    key: 'setMounted',
    value: function setMounted() {
      this.setState({
        mounted: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var settings = {
        dots: true,
        infinite: false,
        responsive: [{
          breakpoint: 768,
          settings: {
            arrows: false
          }
        }]
      };

      var images = this.props.images.map(function (image) {
        return _react2.default.createElement(
          'div',
          { key: image },
          _react2.default.createElement(_ContentCardImage2.default, { src: image, alt: _this2.props.alt })
        );
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactSlick2.default,
          settings,
          this.state.mounted ? images : images[0]
        ),
        _react2.default.createElement(_style2.default, {
          styleId: _ContentCardGallery2.default.__hash,
          css: _ContentCardGallery2.default
        })
      );
    }
  }]);

  return ContentCardGallery;
}(_react2.default.Component);

ContentCardGallery.propTypes = {
  images: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  alt: _propTypes2.default.string.isRequired
};

exports.default = ContentCardGallery;